module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko_samples/sec03_sp_4b318b106ef9a85f3094944dcf3b988a.jpg";